/** Multi-currency display helpers. Amounts are stored as GBP internally; display
 * uses the user's preferred currency symbol (no FX conversion — fair MVP). */

const SYMBOLS = {
  GBP: "£", NGN: "₦", USD: "$", EUR: "€",
  KES: "KSh ", ZAR: "R", GHS: "GH₵ ", CAD: "C$",
  AED: "AED ", PHP: "₱", JMD: "J$", TTD: "TT$", XCD: "EC$",
  INR: "₹", BRL: "R$",
};

let CURRENT = "GBP";

export function setDisplayCurrency(currency) {
  if (SYMBOLS[currency]) CURRENT = currency;
}

export function getDisplayCurrency() {
  return CURRENT;
}

export function moneySymbol(currency = CURRENT) {
  return SYMBOLS[currency] || "£";
}

export function formatMoney(amount, currency = CURRENT, opts = {}) {
  const n = Number(amount ?? 0);
  const sym = moneySymbol(currency);
  const digits = opts.integer || n >= 1000 ? 0 : 2;
  const fixed = n.toLocaleString("en-GB", { minimumFractionDigits: digits, maximumFractionDigits: digits });
  return `${sym}${fixed}`;
}
